module.exports = __webpack_public_path__ + "res/Roboto-ThinItalic-webfont.ttf?daf76183e258a92b6d51ce491b8ce77a";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-ThinItalic-webfont.ttf
// module id = 59
// module chunks = 0